import { EvmABI } from 'src/core/wallets/utils/abi';

export const erc721Abi = [{
    'inputs': [{
        'internalType': 'string',
        'name': '_name',
        'type': 'string',
    }, { 'internalType': 'string', 'name': '_symbol', 'type': 'string' }, {
        'internalType': 'uint256',
        'name': '_maxTokens',
        'type': 'uint256',
    }, { 'internalType': 'address', 'name': '_linkToken', 'type': 'address' }, {
        'internalType': 'address',
        'name': '_chainlinkCoordinator',
        'type': 'address',
    }, { 'internalType': 'uint256', 'name': '_chainlinkFee', 'type': 'uint256' }, {
        'internalType': 'bytes32',
        'name': '_chainlinkHash',
        'type': 'bytes32',
    }],
    'stateMutability': 'nonpayable',
    'type': 'constructor',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
        'indexed': true,
        'internalType': 'address',
        'name': 'approved',
        'type': 'address',
    }, { 'indexed': true, 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'Approval',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
        'indexed': true,
        'internalType': 'address',
        'name': 'operator',
        'type': 'address',
    }, { 'indexed': false, 'internalType': 'bool', 'name': 'approved', 'type': 'bool' }],
    'name': 'ApprovalForAll',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{
        'indexed': true,
        'internalType': 'address',
        'name': 'previousOwner',
        'type': 'address',
    }, { 'indexed': true, 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }],
    'name': 'OwnershipTransferred',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'string', 'name': 'baseURI', 'type': 'string' }],
    'name': 'SetBaseURI',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{
        'indexed': false,
        'internalType': 'uint256',
        'name': 'chainlinkFee',
        'type': 'uint256',
    }, { 'indexed': false, 'internalType': 'bytes32', 'name': 'chainlinkHash', 'type': 'bytes32' }],
    'name': 'SetChainlinkConfig',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'string', 'name': 'defaultURI', 'type': 'string' }],
    'name': 'SetDefaultURI',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'minter', 'type': 'address' }],
    'name': 'SetMinter',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': false, 'internalType': 'uint256', 'name': 'seed', 'type': 'uint256' }, {
        'indexed': false,
        'internalType': 'bytes32',
        'name': 'requestId',
        'type': 'bytes32',
    }],
    'name': 'SetRandomSeed',
    'type': 'event',
}, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'from', 'type': 'address' }, {
        'indexed': true,
        'internalType': 'address',
        'name': 'to',
        'type': 'address',
    }, { 'indexed': true, 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'Transfer',
    'type': 'event',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'to', 'type': 'address' }, {
        'internalType': 'uint256',
        'name': 'tokenId',
        'type': 'uint256',
    }],
    'name': 'approve',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'owner', 'type': 'address' }],
    'name': 'balanceOf',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'baseURI',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'chainlinkFee',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'chainlinkHash',
    'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'defaultURI',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'finalBaseURI',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'getApproved',
    'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
        'internalType': 'address',
        'name': 'operator',
        'type': 'address',
    }],
    'name': 'isApprovedForAll',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'maxTokens',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'uint256', 'name': '_tokenId', 'type': 'uint256' }],
    'name': 'metadataOf',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': '_to', 'type': 'address' }, {
        'internalType': 'uint256',
        'name': '_count',
        'type': 'uint256',
    }],
    'name': 'mintMultiple',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'minter',
    'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'name',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'owner',
    'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'ownerOf',
    'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'bytes32', 'name': 'requestId', 'type': 'bytes32' }, {
        'internalType': 'uint256',
        'name': 'randomness',
        'type': 'uint256',
    }],
    'name': 'rawFulfillRandomness',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'renounceOwnership',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'from', 'type': 'address' }, {
        'internalType': 'address',
        'name': 'to',
        'type': 'address',
    }, { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'safeTransferFrom',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'from', 'type': 'address' }, {
        'internalType': 'address',
        'name': 'to',
        'type': 'address',
    }, { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }, {
        'internalType': 'bytes',
        'name': '_data',
        'type': 'bytes',
    }],
    'name': 'safeTransferFrom',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'seed',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'seedReveal',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'operator', 'type': 'address' }, {
        'internalType': 'bool',
        'name': 'approved',
        'type': 'bool',
    }],
    'name': 'setApprovalForAll',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'string', 'name': 'baseURI_', 'type': 'string' }, {
        'internalType': 'bool',
        'name': 'finalBaseUri_',
        'type': 'bool',
    }],
    'name': 'setBaseURI',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'uint256', 'name': '_chainlinkFee', 'type': 'uint256' }, {
        'internalType': 'bytes32',
        'name': '_chainlinkHash',
        'type': 'bytes32',
    }],
    'name': 'setChainlinkConfig',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'string', 'name': '_defaultURI', 'type': 'string' }],
    'name': 'setDefaultURI',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': '_minter', 'type': 'address' }],
    'name': 'setMinter',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'bytes4', 'name': 'interfaceId', 'type': 'bytes4' }],
    'name': 'supportsInterface',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'symbol',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'uint256', 'name': 'index', 'type': 'uint256' }],
    'name': 'tokenByIndex',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
        'internalType': 'uint256',
        'name': 'index',
        'type': 'uint256',
    }],
    'name': 'tokenOfOwnerByIndex',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'tokenURI',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'from', 'type': 'address' }, {
        'internalType': 'address',
        'name': 'to',
        'type': 'address',
    }, { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256' }],
    'name': 'transferFrom',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}, {
    'inputs': [{ 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }],
    'name': 'transferOwnership',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
}] as EvmABI;
